export default __webpack_public_path__ + "static/media/pers_pc@2x.af95de18.jpg";